import React, { useEffect, useState } from 'react'
import Navbar from 'src/components/Navbar/Navbar'
import Footer from 'src/components/Footer/Footer'
import PostGraduateSubsOpenContent from 'src/components/PostGraduationContent/PostGraduationDetails/Subscribe/Forms/PostGraduateSubscriptionOpen'
import PostGraduateSubsClosedContent from 'src/components/PostGraduationContent/PostGraduationDetails/Subscribe/Forms/PostgraduateEnrollment'
import EmptyLoading from 'src/components/PostGraduationContent/PostGraduationDetails/Subscribe/Forms/PostGraduateSubscriptionLoading'

import subscriptionClosed from 'src/services/time'

const PostGraduateSubscribe = (props: any) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isClosed, setIsClosed] = useState(false)

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, [])

  useEffect(() => {
    subscriptionClosed().then((closed) => {
      setIsClosed(closed ?? false)
      setIsLoading(false)
    })
  }, [])

  return (
    <>
      <Navbar />

      {isLoading && <EmptyLoading />}

      {!isLoading && isClosed && (
        <PostGraduateSubsClosedContent {...props} />
      )}

      {!isLoading && !isClosed && (
        <PostGraduateSubsOpenContent {...props} />
      )}

      <Footer />
    </>
  )
}

export default PostGraduateSubscribe
